import React, { useEffect, useState, useRef } from "react";
import SellSystemLeads from "./sellSystemLeads.js";
import SellSystemCalendar from "./sellSystemCalendar.js";
import { secretKey, monthData } from "../.././data";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal2);

const AddSellSystemTaskDoTask = (props) => {
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [finalDate, setFinalDate] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1 < 10
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate() < 10
        ? "0" + new Date().getDate()
        : new Date().getDate())
  );
  const [note, setNote] = useState("");
  const [taskType, setTaskType] = useState([]);
  const [users, setUsers] = useState([]);
  const [responsible, setResponsible] = useState(props.uData.name);
  const [task, setTask] = useState("");

  const fetchTaskType = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSellTaskType", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTaskType(data);
        fetchUsers();
      })
      .catch((error) => {});
  };

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSellUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchTaskType();
  };

  useEffect(() => {
    getData();
  }, []);

  const addTask = async () => {
    if (validateTask()) {
      setLoading(true);

      var body = {
        startDate: startDate,
        finalDate: finalDate,
        leadName: props.taskData.leadName,
        task: props.leadData.type === "SKD" ? task + " - SKD" : task,
        responsible: responsible,
        noteTask: note,
        status: "ZLECONE",
        leadId: props.lead,
        addUser: props.user.name,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addSellTask", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then(async (data) => {
          props.close();
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const editTask = async () => {
    if (validateTask()) {
      setLoading(true);

      var body = {
        startDate: startDate,
        finalDate: finalDate,
        leadName: props.taskData.leadName,
        task: props.leadData.type === "SKD" ? task + " - SKD" : task,
        responsible: responsible,
        noteTask: note,
        status: "ZLECONE",
        leadId: props.taskData.leadId,
        addUser: props.user,
        taskId: props.taskData.id,
      };

      await fetch("https://apidevkppp.ftpeople.pl/editSellTask", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then(async (data) => {
          MySwal.fire({
            icon: "success",
            title: "Edytowano",
            text: "zadanie sprzedażowe",
          }).then(() => {
            props.close();
          });
        })
        .catch((error) => {});
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validateTask = () => {
    if (
      startDate.length === 0 ||
      finalDate.length === 0 ||
      task.length === 0 ||
      responsible.length === 0
    ) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      <div
        style={{ width: "50vw", paddingBottom: "5vh", top: "20vh" }}
        className="mainContainerAddClientContact"
      >
        <div
          style={{ width: "100%", marginBottom: "1vh" }}
          className="closeBox"
        >
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="inputBox">
          <div style={{ minWidth: "49%" }} className="inputCol_2">
            <label>
              Data realizacji
              <span className="requiredStar">*</span>
            </label>
            <input
              type="date"
              id="date"
              name="date"
              value={finalDate}
              onChange={(e) => {
                setFinalDate(e.target.value);
              }}
              min="2002-01-01"
            />
          </div>
          <div style={{ minWidth: "49%" }} className="inputCol_2">
            <label>
              Zadanie
              <span className="requiredStar">*</span>
            </label>
            <select
              style={{ boxSizing: "border-box" }}
              type="text"
              id="name"
              name="name"
              value={task}
              onChange={(e) => {
                setTask(e.target.value);
              }}
            >
              {!task ? (
                <>
                  <option key={0} value={0}>
                    Wybierz...
                  </option>
                </>
              ) : (
                ""
              )}
              {taskType.map((el) => (
                <>
                  <option key={el.name} value={el.name}>
                    {el.name}
                  </option>
                </>
              ))}
            </select>
          </div>
        </div>

        <div
          style={{ justifyContent: "left" }}
          className="acceptButtonContainer"
        >
          <button
            style={{ backgroundColor: "white" }}
            className="acceptButton"
            onClick={props.mode === "edit" ? editTask : addTask}
          >
            {props.mode === "edit" ? "EDYTUJ ZADANIE" : "DODAJ ZADANIE"}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddSellSystemTaskDoTask;
